export default __webpack_public_path__ + "static/media/about-pic.8777f7ea.jpg";